import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import ListYourItemsButton from '../ListYourItemsButton/ListYourItemsButton';
import css from './FoundingPartner.module.css';
import badgeImage from './badge.png';

// Small arrow used inside the call-to-action button (matches the design mockup).
const ArrowIcon = () => (
  <svg
    className={css.ctaArrow}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

// "Become a Causee Founding Partner" — a new pre-launch incentive section.
// Layout, colours and spacing follow the design mockup (MoreCausesv2.dc.html),
// rebuilt mobile-first and using the site's Gilroy heading font.
const FoundingPartner = () => {
  const intl = useIntl();

  return (
    <section className={css.section}>
      <div className={css.card}>
        <div className={css.decorWash} aria-hidden="true" />

        <div className={css.content}>
          <span className={css.badge}>
            <span className={css.badgeDot} aria-hidden="true" />
            <FormattedMessage id="CustomLandingPage.foundingPartner.badge" />
          </span>

          <h2 className={css.heading}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.heading" />
          </h2>
          <h3 className={css.subheading}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.subheading" />
          </h3>

          <p className={css.body}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.body1" />
          </p>
          <p className={css.body}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.body2" />
          </p>

          <ListYourItemsButton linkClassName={css.ctaLink} buttonClassName={css.cta}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.cta" />
            <ArrowIcon />
          </ListYourItemsButton>
        </div>

        <div className={css.aside}>
          <img
            className={css.badgeImage}
            src={badgeImage}
            alt={intl.formatMessage({ id: 'CustomLandingPage.foundingPartner.badgeImageAlt' })}
          />
          <p className={css.asideText}>
            <FormattedMessage id="CustomLandingPage.foundingPartner.aside" />
          </p>
        </div>
      </div>
    </section>
  );
};

export default FoundingPartner;
